import { DeviceProfile } from "@/__generated__/graphql";
import { Box, Typography } from "@mui/material";
import { getMetricIcon } from "@features/alertsConfigurationV2/utils/metricUtils";

interface ConfiguredMetricCardProps {
  metric: string;
  deviceProfile?: Partial<DeviceProfile>;
}

export const ConfiguredMetricCard = ({
  metric,
  deviceProfile
}: ConfiguredMetricCardProps) => {
  const IconComponent = getMetricIcon(metric);
  
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        backgroundColor: '#1B2229',
        borderRadius: 2,
        p: 2,
        gap: 2,
        width: 1
      }}
    >
      {/* ícono de la métrica */}
      <Box
        sx={{
          border: '2px solid white',
          borderRadius: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: 100,
          width: 100,
          p: 1
        }}
      >
        <IconComponent sx={{ fontSize: 48 }}/>
        <Box>
          {metric} 
        </Box>
      </Box>

      {/* Información del dispositivo */}
      <Box 
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'start',
          borderRadius: 1,
          height: 1,
          minWidth: 0,
          p: 1
        }}
      >
        <Typography variant='h5'
          noWrap
          sx={{
            width: 1
          }}
        >
          {deviceProfile?.name}</Typography>
        <Typography variant='h5'>ID: {deviceProfile?.id}</Typography>
      </Box>

    </Box>
  );
}
